import { BitfDefaultResponseMapper } from '../default-parser/bitf-default-response.mapper';
export abstract class BitfODataResponseMapper extends BitfDefaultResponseMapper {}
